import React from "react";
import {
  Badge,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import { NewHireJourney } from "models/v2/newHireJourney";
import { FiUsers } from "react-icons/fi";
import HorizontalNewHireSupportTeam from "./HorizontalNewHireSupportTeam";

interface ShowSupportCrewButtonDrawerProps {
  newHireJourney: NewHireJourney;
  buttonSize?: string;
  buttonVariant?: string;
  children?: React.ReactNode;
}

export default function ShowSupporButtontCrewDrawer({
  newHireJourney,
  buttonSize = "sm",
  buttonVariant = "ghost",
  children,
}: ShowSupportCrewButtonDrawerProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Check if any support crew members are missing
  const missingCount = [!newHireJourney.manager, !newHireJourney.buddy, !newHireJourney.peopleTeamContact].filter(
    Boolean,
  ).length;

  const hasMissing = missingCount > 0;

  return (
    <>
      {children ? (
        React.isValidElement(children) ? (
          React.cloneElement(children as React.ReactElement, { onClick: onOpen })
        ) : (
          <Box as="button" onClick={onOpen}>
            {children}
          </Box>
        )
      ) : (
        <Button
          leftIcon={<FiUsers />}
          size={buttonSize}
          variant={buttonVariant}
          onClick={onOpen}
          position="relative"
          pr={hasMissing ? "3" : undefined}
        >
          Show Support Crew
          {hasMissing && (
            <Badge
              colorScheme="red"
              borderRadius="full"
              position="absolute"
              top="-2"
              right="-2"
              fontSize="xs"
              minW="5"
              h="5"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {missingCount}
            </Badge>
          )}
        </Button>
      )}

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader>
            <Flex justify="space-between" align="center">
              Support Crew
            </Flex>
          </DrawerHeader>

          <DrawerBody>
            <HorizontalNewHireSupportTeam newHireJourney={newHireJourney} size="md" />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
